// extracted by mini-css-extract-plugin
module.exports = {"rankingPanel":"rankingPanel","rankingPanel__linkWrapper":"rankingPanel__linkWrapper"};